import React from 'react';
import styled from 'styled-components';

const ContentWrapper = styled.header`
    display: flex;
    flex-direction: column;
    padding: 16px;
    h1 {
        margin-top: 4px;
        font-size: 24px;
        font-weight: 600;
        @media screen and (min-width: 800px) {
            font-size: 20px;
        }
      }
      .author {
          color: #fff;
          opacity: 0.8;
          margin-top: 8px;
          font-size: 14px;
      }
`;

const SourceRow = styled.div`
    margin-bottom: auto;
    * {
        display: inline;
        vertical-align: middle;
    }
    img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        box-shadow: ${({srcShadow}) => srcShadow};
        margin-right: 4px;
    }
    h5 {
        opacity: 0.5;
        font-size: 16px;
        font-weight: 500;
        @media screen and (min-width: 800px) {
            font-size: 14px;
        }
      }
`;

const Tagline = styled.p`
        font-weight: lighter;
        font-size: 16px;
        margin-top: 4px;
        color: #888 !important;
        display: ${props => !props.tagline && 'none'};
        @media screen and (min-width: 800px) {
            font-size: 14px;
        }
`;

export const Content = ({content: { logo, postType, author, tagline, title, source }, srcShadow }) => (
  <ContentWrapper>
    {/* <SourceRow srcShadow={srcShadow}>
      {logo && <img src={logo} />}
      {postType && <h5>{postType}</h5>}
    </SourceRow> */}
    {title && <h1>{title.length < 140 ? title : title.substr(0, 140) + '...'}</h1>}
    {author && <p className="author">By: {author}</p>}
    <Tagline tagline={tagline}>{tagline}</Tagline>
  </ContentWrapper>
);



// WEBPACK FOOTER //
// ./src/components/Card/Content.js